import {
  ProductForm_default
} from "./chunk--chunk-RRQU7OM3.js";
import {
  __async
} from "./chunk--chunk-RQ7252KT.js";

// src/js/components/AjaxCart.js
var AjaxCart = class {
  constructor(el) {
    this.emptyCartContent = el.querySelectorAll("[data-empty-cart-content]");
    this.cartWithItemsContent = document.querySelectorAll("[data-cart-with-items-content]");
    const requestButtons = el.querySelectorAll("[data-ajax-cart-request-button]");
    requestButtons.forEach((button) => {
      button.addEventListener("click", (e) => this.buttonListener(e));
    });
    document.addEventListener("ajaxcart refresh", () => __async(this, null, function* () {
      this.toggleContent();
      const requestButtons2 = document.querySelectorAll("[data-ajax-cart-request-button]");
      requestButtons2.forEach((button) => {
        button.addEventListener("click", (e) => this.buttonListener(e));
      });
      const forms = el.querySelectorAll("[data-product-form]");
      forms.forEach((form) => {
        new ProductForm_default(form, "data-product-form").init();
      });
      document.querySelector("#cart-drawer-toggle").checked = true;
    }));
  }
  buttonListener(e) {
    return __async(this, null, function* () {
      e.preventDefault();
      e.stopPropagation();
      const anchor = e.target.tagName === "a" ? e.target : e.target.closest("a");
      try {
        const reqURL = anchor.href;
        const res = yield fetch(reqURL);
        const cart = yield fetch("/cart.js");
        const cartJson = yield cart.json();
        console.log("cart success", cartJson);
        if (res.status === 200) {
          const cartRes = yield fetch("/?sections=ajaxcart");
          const cartJson2 = yield cartRes.json();
          const div = document.createElement("div");
          div.innerHTML = cartJson2.ajaxcart;
          const cartContent = div.querySelector("[data-ajax-cart-content]");
          const cartEl = document.querySelector("[data-ajax-cart] [data-ajax-cart-content]").parentNode;
          cartEl.innerHTML = "";
          cartEl.appendChild(cartContent);
          const subtotalValue = div.querySelector("[data-subtotal-value]").value;
          const subtotalEls = document.querySelectorAll("[data-subtotal]");
          subtotalEls.forEach((subtotalEl) => {
            subtotalEl.innerHTML = subtotalValue;
          });
          document.dispatchEvent(new CustomEvent("ajaxcart refresh"));
        }
      } catch (err) {
        console.error(err);
      }
    });
  }
  toggleContent() {
    return __async(this, null, function* () {
      const cartRes = yield fetch("/cart.js");
      const cartJson = yield cartRes.json();
      if (cartJson.item_count === 0) {
        this.emptyCartContent.forEach((content) => content.style.display = "block");
        this.cartWithItemsContent.forEach((content) => content.style.display = "none");
      } else {
        this.emptyCartContent.forEach((content) => content.style.display = "none");
        this.cartWithItemsContent.forEach((content) => content.style.display = "block");
      }
    });
  }
  initNavidium() {
    return __async(this, null, function* () {
      let Navidium = yield import("./chunk--Navidium-GQHHGCJQ.js");
      Navidium = Navidium.default;
      new Navidium();
    });
  }
};
var AjaxCart_default = AjaxCart;

export {
  AjaxCart_default
};
